const auditTemplate = `<!DOCTYPE html>
<html>
  <head>
  </head>
  <body>
  <div id="appraisalValues">
  <div class="heading"><h6>Audit</h2></div>

      <table>
        <tr class="headerClass leftAlign">
          <th>Date</th>
          <th>Name</th>
          <th>Status</th>
          <th>Comments</th>
        </tr>
        {{#each log}}
        <tr>
          <td>{{this.date}}</td>
          <td>{{this.createdBy}}</td>
          <td>{{this.status}}</td>
          <td>{{this.comments}}</td>
        </tr>
        {{/each}}

        {{#if (eq this.empty 'true')}}
        <tr>
          <td colspan="4">No  Data</td>
        </tr>
        {{/if}}
      </table>
    </div>
  </body>
</html>
`;
export default auditTemplate;


// <style>
// body {
//   font-family: Roboto, Helvetica, Arial, sans-serif;
// }
// table {
//   width: 100%;
//   border-radius: 3px !important;
// }
// th,
// td {
//   align-items: left !important;
//   justify-content: left !important;
//   text-align: left !important;
//   padding: 15px;
//   border-right: none; /* This will remove the right border for all table cells */
// }
// .border {
//   width: 100%;
//   border: 0.5px solid #263746;
//   border-radius: 3px;
// }

// .heading {
//   margin: 0 !important;
//   background-color: #263746;
//   color: #fff;
//   padding: 10px;
// }

// th > .leftAlign {
//   align-items: left !important;
//   justify-content: left !important;
//   text-align: left !important;
// }

// .headerClass {
//   background-color: grey;
// }
// </style>